import { FeelingListSkeleton } from './chunk-S5E7VNPE.mjs';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { jsx, jsxs } from 'react/jsx-runtime';

var FeelingList = (props) => {
  const { activeId, onSelect, queryRs } = props;
  const { isLoading, data } = queryRs;
  if (isLoading) {
    return /* @__PURE__ */ jsx(FeelingListSkeleton, {});
  }
  const { tags: feelings } = data;
  return /* @__PURE__ */ jsxs(Stack, { role: "radiogroup", "aria-label": "feeling list", direction: "row", spacing: 1, my: 2, sx: { overflowX: "auto" }, children: [
    /* @__PURE__ */ jsx(
      Chip,
      {
        label: "Default",
        color: !activeId ? "primary" : "default",
        "aria-pressed": !activeId,
        role: "button",
        onClick: () => onSelect("")
      }
    ),
    feelings.map((f) => {
      const isActive = !!activeId && f.id === activeId;
      const color = isActive ? "primary" : "default";
      return /* @__PURE__ */ jsx(
        Chip,
        {
          label: f.name,
          color,
          "aria-pressed": isActive,
          role: "button",
          onClick: () => onSelect(f.id)
        },
        f.id
      );
    })
  ] });
};

export { FeelingList };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-5C2YTDHO.mjs.map